import React from 'react';
import { NavLink } from 'react-router-dom';
import { useTranslation } from '../../../../hooks/useTranslation';

const TABS = [
    { key: 'today', path: '/dashboard/operations', end: true },
    { key: 'forecast', path: '/dashboard/operations/forecast' },
    { key: 'observation', path: '/dashboard/operations/observation' },
    { key: 'endOfStay', path: '/dashboard/operations/end-of-stay' },
];

const OperationsNav = ({ className = 'mb-4' }) => {
    const { t } = useTranslation();

    return (
        <nav className={`ops-tabs ${className}`} aria-label="Sections opérations">
            <ul className="ops-tabs__list">
                {TABS.map((tab) => (
                    <li key={tab.key}>
                        <NavLink
                            to={tab.path}
                            end={tab.end}
                            className={({ isActive }) => `ops-tabs__link${isActive ? ' is-active' : ''}`}
                        >
                            {t(`pages.operationsDashboard.tabs.${tab.key}`)}
                        </NavLink>
                    </li>
                ))}
            </ul>
        </nav>
    );
};

export default OperationsNav;
